export const getCursorFromUrl = (url?: string | null) =>
  url && new window.URL(url).searchParams.get('page');
